<template>
  <transition
    enter-active-class="animate__animated animate__bounceIn"
    leave-active-class="animate__animated animate__bounceOut"
    mode="out-in"
  >
    <div class="NowPlaying">
      <Overlay />
    </div>
  </transition>
</template>

<script>
import Overlay from "@/components/Overlay";
const querystring = require("querystring");

export default {
  name: "About",
  components: {
    Overlay,
  },
  data(){
    return {
      refresh_token: ""
    };
  },
  methods: {
    goto: function(link) {
      location.href = link;
    },
    redirect() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      console.log('Redirecting');
      console.log(params.refresh_token);
      this.goto(
      "refreshtoken?" +
        querystring.stringify({
          refresh_token: params.refresh_token,
        })
      );
    },
  },
  created() {
    setInterval(this.redirect, 3599998);
  },
};
</script>
